module.exports = __webpack_public_path__ + "img/terre_on.92328961.gif";